<template>
    <div id="legalRuleDetail" data-role="page">
        <!-- content -->
        <div class="legalRuleDetail-content" data-position="fixed">
            <div class="detailWrap">
                <div class="detail-h">
                    <h3><span>{{Rules.rule_chapter}}</span><br><span>{{Rules.rule_name}}</span></h3>
                </div>
                <div class="detail-c">
                    <h4 class="cgyTitle"><i class="titleIcon icon-law"></i>法條內容<i v-if="Authority" v-on:click="SetFavorites(Rules.rule_id,Rules.is_keep,2)" :class="[Rules.is_keep ? 'icon-bookmark-full active' : 'icon-bookmark','bookmarkIcon']"></i></h4>
                    <div class="cgyContent" v-html="Rules.content">
                    </div>
                </div>
            </div>
            <!-- 相關文章 (有相關文章的時候再顯示該區塊)-->
            <div class="detailWrap articleWrap" v-if="articles.length>0">
                <div class="detail-c">
                    <h4 class="cgyTitle"><i class="titleIcon icon-article-pen"></i>相關文章</h4>
                    <div class="cgyContent">
                        <div class="articleList">
                            <ul>
                                <li v-for="(article,article_ind) in articles" :key="article_ind">
                                    <router-link :to="{name:'newsDetail',params:{id:article.news_id}}">
                                        <div class="topicImg">
                                            <div class="mainImg" v-if="article.title_img == ''"></div>
                                            <div class="mainImg" :style="'background-image:url('+article.title_img+')'" v-if="article.title_img != ''"></div>                                            
                                        </div>
                                        <div class="txt-info">
                                            <span class="article_desc">{{article.title}}</span>
                                            <span class="article_date">{{article.news_date.split(' ')[0]}}</span>
                                            <div class="metaDiv">
                                                <span class="cgy-tag">法律知識</span>
                                                <span v-if="Authority" class="bookmark-tag" v-on:click.prevent="SetFavorites(article.news_id,article.is_keep,0)"><i :class="[article.is_keep ? 'icon-bookmark-full active' : 'icon-bookmark','bookmarkIcon']"></i></span>
                                            </div>
                                        </div>
                                    </router-link>
                                </li>
                            </ul>
                            <p class="moreBtn" v-if="now_row<=this.articles.length && this.articles.length >=10" v-on:click="GetMoreArticles">顯示更多</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /相關文章 -->
        </div>
        <!-- /content -->
    	<favoritesToast
        :show="toastControl.show"
        :full="toastControl.full"
        :content="toastControl.content"
        :showTime="toastControl.showTime"
        @close="toastControl.show = false"
        ></favoritesToast>
    </div>
</template>
<script lang="js">
import favoritesToast from '@/components/common/toast/favoritesToast';
export default {
    components: { favoritesToast },
    data () {
        return {
            Rules:[],
            now_row: 10,
            articles: [],
            more_btn: true,
            Imgurl:Imgurl,
            Authority:false,
            toastControl:{
                show: false,
                full: false,
                content: '',
                showTime: 1000
            }
        }
    },
  mounted(){ 
    let vobj = this;
    vobj.GetRuleDetail();
    vobj.GetArticle();
    vobj.CheckAuthority();
  },
  methods:{
      //取的法規細節
      GetRuleDetail(){
        let vobj = this;
        let rule_id = this.$route.params.id;
        this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetCommitteeLegalRuleDetail/${rule_id}`,{
            headers:{Authorization: Token},
        }).then((response) => {
            if(response.status == 200){
            vobj.Rules =  response.data.data
            console.log(vobj.Rules);
            }
        })          
      },
      //取的相關文章
      GetArticle(){
        let vobj = this;
        let rule_id = this.$route.params.id;
        this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetRuleRelatedCommitteeNews/${rule_id}/${1}/${this.now_row}`,{
            headers:{Authorization: Token},
        }).then((response) => {
            if(response.status == 200){
                vobj.articles =  response.data.data
                console.log(vobj.articles);
                if(vobj.articles.length != 10){
                    vobj.more_btn = false;
                }
            }
        })
      },
      //設定收藏
      SetFavorites(id,status,type){
          let vobj = this;
          if(vobj.toastControl.show) return false
          let status_val = 0;
          status ? (status_val=0 ) : (status_val=1);
          vobj.$root.SetFavorites(type,id,status_val,function(res){
              if(res){
                  switch (type) {
                      case 0:
                          vobj.articles.map(function(val,ind){
                              if(val.news_id ==id){vobj.articles[ind]['is_keep']=status ? (false):(true);}
                          })
                          break;
                      case 2:
                          vobj.Rules['is_keep']=status ? (false):(true);
                          break;
                  }
                  status ? vobj.UnfavoritesToast() : vobj.FavoritesToast()
              }
          });
      },
      //檢查權限
      CheckAuthority(){
          if(localStorage.getItem("token")=='' || localStorage.getItem("token") == null){
              this.Authority= false
          }else{
              this.Authority= true
          }
      },
      //取的更多相關文章
      GetMoreArticles(){
          this.now_row+=10;
          this.GetArticle();
      },
      	FavoritesToast(){
            this.toastControl.content = '已加入收藏'
            this.toastControl.full = true
            this.toastControl.show = true
        },
        UnfavoritesToast(){
            this.toastControl.content = '已取消收藏'
            this.toastControl.full = false
            this.toastControl.show = true
        }	

  }
}
</script>


// WEBPACK FOOTER //
// src/components/legalRuleDetail.vue